export default {
  width: ['10px', '15px'],
  height: ['10px', '15px'],
  backgroundColor: 'tmRed',
  borderRadius: '100%',
  border: 'transparent',
  cursor: 'pointer',
  padding: '0px',
}
